import React, { useRef } from 'react';
import {
  Grid,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import FormButton from '../../../shared/FormButton';
import submitForm from '../../../../api/submitForm';
import { func, bool } from 'prop-types';
import styles from './index.styles';
import { ContactSchema } from '../../../../utils/form-validations';
import { Field, Form, Formik } from 'formik';
import { scrollToElement } from '../../../../utils/functions';
import useGetContactPageTranslation from '../../../../hooks/useGetContactPageTranslation';

const useStyles = makeStyles(styles);

const initialFormValues = {
  name: '',
  emailOrPhoneNumber: '',
  tellUsMore: '',
};

const ContactForm = ({ setFormIsSent, formIsSent }) => {
  const topOfForm = useRef();
  const { form } = useGetContactPageTranslation();

  const theme = useTheme();
  const classes = useStyles({ formIsSent });
  const smallScreen = useMediaQuery(
    theme.breakpoints.down('xs')
  );

  const inputLabelStyle = {
    top: smallScreen ? 0 : -5,
  };
  const textareaLabelStyle = {
    top: smallScreen ? 7 : 0,
  };

  const handleSubmit = async (
    values,
    { setSubmitting }
  ) => {
    try {
      await submitForm('contact-form', values);
      setFormIsSent(true);
      setSubmitting(false);
      scrollToElement(topOfForm.current);
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    }
  };

  const contactForm = [
    {
      name: 'name',
      inputStyle: inputLabelStyle,
      label: form.labels[0],
      multiline: false,
    },
    {
      name: 'emailOrPhoneNumber',
      inputStyle: textareaLabelStyle,
      label: form.labels[1],
      multiline: true,
    },
    {
      name: 'tellUsMore',
      inputStyle: textareaLabelStyle,
      label: form.labels[2],
      multiline: true,
    },
  ];

  if (formIsSent) {
    return null;
  }

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={ContactSchema}
      onSubmit={handleSubmit}
      validateOnBlur={true}
    >
      {({
        dirty,
        isValid,
        isSubmitting,
        errors,
        touched,
      }) => (
        <Form
          className={classes.form}
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          name="contact-form"
          action="/"
          ref={topOfForm}
        >
          <Grid container direction="column">
            {contactForm.map((formField) => (
              <Field
                name={formField.name}
                key={formField.name}
              >
                {({ field }) => (
                  <TextField
                    InputLabelProps={{
                      style: formField.inputStyle,
                    }}
                    label={formField.label}
                    type="text"
                    error={
                      errors[formField.name] &&
                      touched[formField.name]
                    }
                    className={`${classes.formField} ${
                      !field.value
                        ? classes.emptyFormField
                        : ''
                    }`}
                    multiline={formField.multiline}
                    {...field}
                  />
                )}
              </Field>
            ))}
            <Grid container item justify="center">
              <FormButton
                title={form.buttonText}
                tailed
                isDisabled={
                  !isValid || !dirty || isSubmitting
                }
              />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

ContactForm.propTypes = {
  setFormIsSent: func,
  formIsSent: bool,
};

export default ContactForm;
